package org.gstechnovos.jexonplastech.sections.product_details.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.dom.ref
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.gstechnovos.jexonplastech.util.animateSlideUp
import org.gstechnovos.jexonplastech.util.rememberScrollVisibility
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

@Composable
fun ProductSpecificationsSection(specifications: Map<String, String>) {
    val palette = ColorMode.current.toSitePalette()
    val (isVisible, visibilityRef) = rememberScrollVisibility(threshold = 0.1)

    Div(
        attrs = Modifier
            .fillMaxWidth()
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .alignItems(com.varabyte.kobweb.compose.css.AlignItems.Center)
            .toAttrs {
                ref { element ->
                    visibilityRef(element)
                    onDispose {}
                }
            }
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .maxWidth(1200.px)
                .padding(leftRight = 5.percent, topBottom = 20.px)
                .animateSlideUp(isVisible, delayMs = 150)
        ) {
            SpanText(
                text = "Specifications",
                modifier = Modifier
                    .fontSize(24.px)
                    .fontWeight(FontWeight.Bold)
                    .color(palette.custom.darkText)
                    .margin(bottom = 16.px)
            )

            // Matrix displaying technical details with interactive row hovering
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .borderRadius(8.px)
                    .border(width = 1.px, style = LineStyle.Solid, color = palette.custom.lightGray)
            ) {
                specifications.entries.forEachIndexed { index, (key, value) ->
                    var isRowHovered by remember { mutableStateOf(false) }

                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .backgroundColor(
                                if (isRowHovered) palette.brand.primaryBlue.toRgb().copyf(alpha = 0.05f)
                                else palette.custom.white
                            )
                            .then(
                                if (index < specifications.size - 1)
                                    Modifier.borderBottom(width = 1.px, style = LineStyle.Solid, color = palette.custom.lightGray)
                                else Modifier
                            )
                            .transition(Transition.of(TransitionProperty.All, duration = 200.ms))
                            .onMouseEnter { isRowHovered = true }
                            .onMouseLeave { isRowHovered = false }
                    ) {
                        Box(
                            modifier = Modifier
                                .width(30.percent)
                                .backgroundColor(
                                    if (isRowHovered) palette.brand.primaryBlue.toRgb().copyf(alpha = 0.1f)
                                    else palette.custom.lightGray.toRgb().copyf(alpha = 0.3f)
                                )
                                .padding(16.px)
                                .transition(Transition.of(TransitionProperty.All, duration = 200.ms))
                        ) {
                            SpanText(
                                text = key,
                                modifier = Modifier
                                    .fontWeight(FontWeight.Bold)
                                    .color(if (isRowHovered) palette.brand.primaryBlue else palette.custom.darkText)
                            )
                        }
                        Box(modifier = Modifier.width(70.percent).padding(16.px)) {
                            SpanText(
                                text = value,
                                modifier = Modifier.color(palette.custom.darkText)
                            )
                        }
                    }
                }
            }
        }
    }
}